import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';

/*
This component relies on 'email-third-button' and 'email-third-header' fields which are only
set for some norwegian exception sites where some of them has the field commented out

I think this has to be refactored as just a specific component for that specific case
*/

const EmailThirdHeader = ({ iimclient }: EmailThirdButtonProps) =>
  iimclient.texts['email-third-header'] && (
    <div dangerouslySetInnerHTML={{ __html: iimclient.texts['email-third-header'] }} />
  );

type EmailThirdButtonProps = {
    iimclient: ConfigClientType;
};

const EmailThirdButton = ({ iimclient }: EmailThirdButtonProps) => {
  const content = iimclient.texts['email-third-button'];
  const hasTextContent = typeof content != 'object' && iimclient.floater_email_thirdurl;

  // content.after property is not being applied
  const styles = {
    backgroundColor: content.bgcolor || '',
    marginTop: content.marginTop ||  '',
    color: content.color && `${content.color} !important` ||  '',
  }

  const text = hasTextContent && content || content.visual

  return (
    <>
      <EmailThirdHeader iimclient={iimclient} />
      <a
        href={iimclient.floater_email_thirdurl}
        className="if button secondary same-width"
        target="_blank"
        id="email-third-button"
        role="button"
        rel="noreferrer"
        style={styles}>
        {text}
      </a>
    </>
  );
};

export default EmailThirdButton;
